import React from 'react';

import UserSelection from '../../Organisms/UserSelection';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
export interface INotificationsUserDetailsProps {
    users: any[];
    userSelectionHook: any;
    setSelection:any;
    usersTargetType:'all' | 'custom';
}

const   NotificationUserDetails = ({ userSelectionHook, setSelection, usersTargetType }: INotificationsUserDetailsProps) => {
    const handleChange = ((evt: any) =>{
        setSelection(evt.target.value)
    })
    return (
        <>
        <Select defaultValue={usersTargetType} onChange={handleChange}>
                <MenuItem  value={'all'} >
                    All users
                </MenuItem>
        </Select>
            {usersTargetType === 'custom' && <UserSelection label="Notification-create" userSelectionHook={userSelectionHook} /> }
        </>
    )
};

export default NotificationUserDetails;
